export enum TimeAggregationEnum {
  Base = 1,
  Daily = 2,
  Weekly = 3,
  Monthly = 4,
  Yearly = 5,
  NotApplicable = 6,
  Hourly = 7,
}
